export enum  RTS_DETAIL_COLUMN_NAME {
    REASON="reason",
    TOTAL_PACKAGES="totalPackages",
    TIMESTAMP="timestamp",
}

export enum  RTS_DETAIL_HEADER_NAME {
    REASON="Reason",
    TOTAL_PACKAGES="Total Packages",
    TIMESTAMP="Latest Scan Time",
}